<template>
    <div class="text-center">
		<v-dialog
			v-model="show"
			width="600"
			@input="(v) => v || closeModal()"
			content-class="add-question-modal overflow-x-hidden"
            @click:outside="closeModal"
		>
            <v-card class="add-question-modal__card">
                <div class="d-flex mb-4 align-center flex-wrap mr-5">
					<div class="add-question-modal__title">
						Add a Question
					</div>
				</div>
                <SessionQuestionForm 
                    :qaIsAutocomplete="qaIsAutocomplete" 
                    :isQuestionsPage="isQuestionsPage"
                    v-on:closeModal="closeModal"
                />
                <v-btn 
                    icon 
                    class="add-question-modal__button-close"
                    style="background-color: transparent !important;"
                    @click="closeModal"
                >
                    <v-icon color="#0055A3">mdi-close</v-icon>
                </v-btn>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import SessionQuestionForm from '@/components/Forms/SessionQuestionForm.vue';
export default {
    components: {
        SessionQuestionForm
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        qaIsAutocomplete: {
            type: Boolean,
            default: false
        },
        isQuestionsPage: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('closeModal')
        }
    }
}
</script>

<style lang="scss">
.add-question-modal {
	border-radius: 10px;
    background-color: #fff;

    &__card {
        position: relative;
        padding: 30px;
    }

    &__title {
		color: var(--accent-color);
		font-size: 24px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
	}

    &__button-close {
        position: absolute;
        top: 20px;
		right: 20px;
    }
}
</style>